import * as React from 'react';
import { Theme, makeStyles, createStyles } from '@bb-ui/react-library';
import { AppBar, Toolbar } from '@bb-ui/react-library/dist/components';
import { BbThemeProvider } from '@bb-ui/react-library/dist/components/BbThemeProvider';
import { HeaderUserMenu } from './HeaderUserMenu';
import { Logo } from 'components/Logo';
import { useExperience } from 'contexts/ExperienceContext';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      gridArea: 'header',
      boxShadow: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
      backgroundColor: 'rgba(247, 247, 247, 0.85)',
      backdropFilter: 'blur(20px)',
      zIndex: 5,
    },
    headerContent: {
      justifyContent: 'flex-end',
      color: theme.palette.text.primary,
      minHeight: '44px',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(2.5),
    },
    subTitle: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    headerClassic: {
      gridArea: 'header',
      boxShadow: '0 0 3px 0 rgba(0,0,0, 0.1)',
      backgroundColor: theme.palette.common.black,
    },
    headerContentClassic: {
      justifyContent: 'space-between',
      color: theme.palette.text.primary,
    },
  }),
);

export const Header: React.FC = (props) => {
  const classes = useStyles(props);
  const { isClassic } = useExperience();

  if (isClassic) {
    return (
      <BbThemeProvider theme="dark">
        <AppBar
          className={classes.headerClassic}
          position="sticky"
          color="inherit"
          data-testid="app-header"
        >
          <Toolbar className={classes.headerContentClassic}>
            <Logo />
            <HeaderUserMenu />
          </Toolbar>
        </AppBar>
      </BbThemeProvider>
    );
  }

  return (
    <AppBar className={classes.header} position="sticky" color="inherit" data-testid="app-header">
      <Toolbar className={classes.headerContent} />
    </AppBar>
  );
};
